export default __webpack_public_path__ + "static/media/antelope-3-thumbnail.7cce44d6.jpg";